import { Divider, Stack } from "@mui/material";
import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";

export default function ProtectedLayout({ allowedRoles }) {
    const token = localStorage.getItem("accessToken");
    const role = localStorage.getItem("roleName");

    if (!token || !role) return <Navigate to="/signin" replace />;

    try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        if (payload.exp * 1000 < Date.now()) {
            localStorage.clear();
            return <Navigate to="/signin" replace />;
        }
    } catch {
        localStorage.clear();
        return <Navigate to="/signin" replace />;
    }

    if (allowedRoles && !allowedRoles.includes(role)) {
        return <Navigate to="/dashboard" replace />;
    }

    return (
        <Stack
            sx={{
                width: "100vw",
                height: "100vh",
                overflow: "hidden",
                background: "var(--bg)",
            }}
        >
            <Stack sx={{ width: "100%", height: "60px" }}>
                <Navbar />
                <Divider />
            </Stack>

            <Stack
                sx={{
                    flex: 1,
                    width: "100%",
                    height: "calc(100vh - 60px)",
                    flexDirection: "row",
                }}
            >
                <Stack
                    sx={{
                        display: {
                            xs: "none",
                            sm: "flex",
                            height: "100%",
                            flexDirection: "row",
                        },
                    }}
                >
                    <Sidebar />

                    <Divider orientation="vertical" />
                </Stack>

                <Stack
                    sx={{
                        flex: 1,
                        overflowY: "auto",
                        overflowX: "hidden",
                        p: { xs: 2, sm: 2.5, md: 3 },
                        height: "100%",
                        width: "100%",
                    }}
                >
                    <Stack sx={{ width: "100%", maxWidth: 1200, mx: "auto" }}>
                        <Outlet />
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    );
}
